import { useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { Box, Flex } from '@chakra-ui/react'
import { MdUnpublished } from "react-icons/md";

import PageLoader from '../../../global/components/helper-components/components/PageLoader'
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton'
import { manageJoinRoom } from '../../../digital-sales-room/actions/manage-dsr-member-actions'
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal'



function ConfirmDeleteJoinRequestModal({
  handleCloseModal,
  modalTransferPayload,
  // Action
  manageJoinRoom,
}) {

  const { dsrTitle, dsrId } = modalTransferPayload || {}

  // UX Management
  const [showLoader, setShowLoader] = useState(false)


  const handleDeleteRequestButton = () => {
    setShowLoader(true);

    manageJoinRoom({
      event: "delete-join-request",
      dsrId: dsrId,
      dsrTitle: dsrTitle
    })
  }

  function displayContent() {
    if (showLoader) {
      return (
        <Box w="100%" align="center" >
          <Box px='1em'>
            <PageLoader />
          </Box>
        </Box>
      )
    }

    if (!showLoader) {
      return (
        <Box w='100%' p='1em 1.8em'>
          <Flex w="100%" fontSize='0.875em' color='brandDark.500'>
            {`Proceed to retract your request to join ${dsrTitle || "this Room"}?`}
          </Flex>

          <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
            <LaunchdeckButton bg='brandPink.500' w={['100%', 'auto']} color='white' fontSize='0.8em' py='0.4em' loadingLogic={showLoader} onClick={() => handleDeleteRequestButton()} label='Yes, withdraw request' />
          </Flex>
        </Box>
      )
    }
  }

  return (
    <LaunchdeckModal
      title={<Flex gap='1em' justify='flex-start' align='center'>
        <Box as={MdUnpublished} color='brandPink.500' boxSize="1.6em" />
        <Box color='white'>Withdraw join room request</Box>
      </Flex>}
      handleCloseModal={() => handleCloseModal()}
      showModal={true}
      maxW='35em'
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}



const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      manageJoinRoom
    },
    dispatch,
  )


export default withRouter(connect(null, mapDispatchToProps)(ConfirmDeleteJoinRequestModal));
